import { FamiliesService } from '@/services/families.service'

export default {
  updateList ({ commit }) {
    console.log(this.state)
    return FamiliesService.list({}, { limit: 0 })
      .then(contacts => {
        commit('SET_FAMILY_LIST', contacts)
      })
  }
}
